import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrowRight.svg'
import styles from './flippingArrow.module.css'
import cn from '../../../utils/cn'

interface IProps {
  isOpen: boolean
}

const FlippingArrow = ({ isOpen }: IProps) => {
  return (
    <div className={styles.flippingArrowWrapper}>
      <ArrowIcon className={cn(styles.flippingArrow, 'asd')} data-open={isOpen ? 'true' : 'false'} />
    </div>
  )
}

export default FlippingArrow
